import React from 'react';
import BigLogo from "../components/BigLogo";
import {Col, Row} from 'react-bootstrap';
import {AppStoreButton, GooglePlayButton} from "react-mobile-app-button";
import ScrollableImageList from "../components/ScrollableImageList";

Landing.propTypes = {};

function Landing() {
    return (
        <div className="d-flex flex-column pb-5">
            <BigLogo/>
            <Row>
                <Col>
                    <h5 className="text-center my-3"> Unleash Your Skills, Claim Victory, and Rule in Paddle
                        Battle!</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ScrollableImageList childCount={11} height={'600px'}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p>
                        Paddle Battle offers an exhilarating journey into the realm of retro-style gaming, where players
                        are thrust into heart-pounding battles armed with nothing but their trusty paddle and a flurry
                        of balls. Set against a backdrop of mesmerizing visual effects, the game pits competitors
                        against each other in a race to score 3 points first. With lightning-fast reflexes and strategic
                        precision, players must navigate the chaos to emerge victorious.
                    </p>

                </Col>

            </Row>
            <Row>
                <Col className={"m-1 d-flex align-items-center justify-content-center"}>

                    <GooglePlayButton className="mx-2"
                                      url={"https://play.google.com/store/apps/details?id=se.attbygga.paddlebattle"}
                                      theme={"dark"}
                    />

                </Col>
                <Col className={"m-1 d-flex align-items-center justify-content-center"}>

                    <AppStoreButton
                        url={"https://apps.apple.com/us/app/paddle-battle-online/id6474252542"}
                        theme={"dark"}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default Landing;